/**
 * @fileoverview Application-specific enumerations and constants.
 */

/**
 * Enumeration of organization status values.
 */
export enum OrganizationStatusEnum {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  DELETED = "DELETED",
}

/**
 * Enumeration of admission signature action types.
 */
export enum AdmissionSignatureActions {
  SAVE_ADMISSION_SIGNATURE = "save-admission-signature",
}

/**
 * Enumeration of document types used throughout the application.
 * These constants represent the different types of documents that can be associated with PDFs.
 */
export enum DocumentType {
  /** PDFs marked with this document type are uploaded separately to PCC and excluded from admission packets. */
  ARBITRATION = "ARBITRATION",
  /** PDFs marked with this document type are included in admission packets. */
  ADMISSION = "ADMISSION",
}

/**
 * Workflow types currently supported in the product. Values are lowercase
 * template keys (e.g. "admission", "arbitration") so they match API + template naming.
 *
 * Templates may still introduce unknown keys — UI treats those as free-form
 * strings (humanized labels, hashed colors).
 */
export enum WorkflowType {
  ADMISSION = "admission",
  ARBITRATION = "arbitration",
}
